/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BusinessAccountTransactionSource {
    AD_TRACTION = 'AdTraction',
    AWIN = 'Awin',
    PARTNER_ADS = 'PartnerAds',
    CARD_LINKING = 'CardLinking',
    VISA = 'Visa',
    DAISY_CON = 'DaisyCon',
    TRADE_DOUBLER = 'TradeDoubler',
    CJ = 'Cj',
    PARTNER = 'Partner',
    WEBSHOP = 'Webshop',
    IMPACT = 'Impact',
}
